<template>
  <section>
    <b-tabs v-model="activeTab">
      <b-tab-item :label="titlePendingCarriers">
        <carrier-approvals/>
      </b-tab-item>

      <b-tab-item :label="titlePendingShipper">
        <shipper-approvals/>
      </b-tab-item>

      <b-tab-item :label="titlePendingPayments">
        <button class="button is-success"
                :class="{ 'is-loading': isCompletingReview }"
                :disabled="!selectedJobIds.length"
                @click="approveSelectedJobs">
          Approve ({{selectedJobIds.length}})
        </button>
        <template v-if="isLoadingTransactions">
          <font-awesome-icon icon="spinner" spin />  Getting list of transactions.
        </template>
        <template v-else>
          <transactions-table :company-jobs="isPendingPayment" @selectionChange="onSelectionChange" :isSelectable="true" />
        </template>
      </b-tab-item>

      <b-tab-item :label="titleActiveJobs">
        <template v-if="isLoadingTransactions">
          <font-awesome-icon icon="spinner" spin />  Checking for new transactions.
        </template>
        <template v-else>
          <transactions-table :company-jobs="isInProgress" />
        </template>
      </b-tab-item>

      <b-tab-item :label="titleCompletedJobs">
        <template v-if="isLoadingTransactions">
          <font-awesome-icon icon="spinner" spin />  Checking for new transactions.
        </template>
        <template v-else>
          <transactions-table :company-jobs="isComplete" />
        </template>
      </b-tab-item>

    </b-tabs>
  </section>
</template>

<script>
import { mapGetters, mapActions, mapState, mapMutations } from 'vuex'

import ShipperApprovals from '@/components/FactoringApprovalsShipperTable'
import CarrierApprovals from '@/components/FactoringApprovalsCarrierTable'
import TransactionsTable from '@/components/TransactionsTable'

export default {
  name: 'FactoringTransactionsDashboard',

  data() {
    return {
      intervalId: null,
      isCompletingReview: false,
      isLoadingTransactions: false,
      selectedJobIds: []
    }
  },

  computed: {
    ...mapGetters('companyJobs', ['isInProgress', 'isPendingPayment', 'isComplete']),
    ...mapGetters('factoring', { carriers: 'pendingApprovalCarriers', shippers: 'pendingApprovalShippers' }),
    ...mapState(['activeFactoringDashboardCategory', 'filterDashboardByUser']),
    ...mapGetters('user', ['accountInfo']),

    titlePendingCarriers() {
      const count = this.carriers.length
      return `Carrier Approvals (${count})`
    },

    titlePendingShipper() {
      const count = this.shippers.length
      return `Shipper Approvals (${count})`
    },

    titlePendingPayments() {
      const count = this.isPendingPayment.length
      return `Pending Payments (${count})`
    },

    titleActiveJobs() {
      // const count = this.isInProgress.length
      return `Active Jobs`
    },

    titleCompletedJobs() {
      // const count = this.isComplete.length
      return `Completed Jobs`
    },

    activeTab: {
      get() {
        return this.activeFactoringDashboardCategory
      },
      set(filterCategory) {
        this.setActiveCategory(filterCategory)
      }
    }
  },

  created() {
    this.intervalId = window.setInterval(this.fetchPendingApprovals, 30000)
    this.fetchTransactions()
  },

  beforeDestroy() {
    window.clearInterval(this.intervalId)
  },

  components: {
    ShipperApprovals,
    CarrierApprovals,
    TransactionsTable
  },

  methods: {
    ...mapActions('companyJobs', {
      fetchTransactionList: 'fetch',
      completeFactoringReview: 'completeFactoringReview'
    }),
    ...mapActions('factoring', ['fetchPendingApprovals']),
    ...mapMutations({
      setActiveCategory: 'SET_ACTIVE_FACTORING_DASHBOARD_CATEGORY'
    }),

    async fetchTransactions() {
      try {
        this.isLoadingTransactions = true
        const factoringProviderKey = this.accountInfo.factoringProvider.factoringProviderKey
        await this.fetchTransactionList({ factoringProviderKey })
      } catch (err) {
        console.log('Unable to fetch new transaction list: ', err)
      } finally {
        this.isLoadingTransactions = false
      }
    },

    /**
     * Keep track  of what rows have been selected in the companyJob table
     */
    onSelectionChange(selection) {
      this.selectedJobIds = [...selection]
    },

    /**
     * Mark selected companyJobs as approved by the factoring provider
     */
    async approveSelectedJobs() {
      try {
        this.isCompletingReview = true
        await this.completeFactoringReview({ companyJobKeys: this.selectedJobIds, isApproved: true })
        this.selectedJobIds = []
        this.fetchTransactions()
      } catch (err) {
        console.log('Error saving companyJob factoring review', err)
      } finally {
        this.isCompletingReview = false
      }
    }
  }
}
</script>

<style lang="scss">
.dashboard {
  .field.is-horizontal .field-label {
    display: block;
    flex: 0;
    white-space: nowrap;
  }
}
</style>
<style scoped lang="scss">
.table-wrapper {
  overflow-x: hidden;
  overflow-y: auto;
  height: 450px;
}

.meta-data {
  td {
    border-width: 0;
    font-size: 0.8rem;
  }
}

section {
  width: 100%;
}
</style>
